import React from 'react';
import { money } from './theme';
import { formatDate } from '../client/dates';

const DAY = 24 * 60 * 60 * 1000;
const daysLeft = (date) => Math.max(0, Math.ceil((new Date(`${date}T12:00:00`) - Date.now()) / DAY));

// The one panel here that is a to-do list rather than a report. It deliberately
// ignores the order-date filter: these were bought a year ago, so any recent window
// would hide every renewal worth chasing.
export default function ExpiringSoon({ expiring }) {
  const rows = expiring?.purchases || [];
  return (
    <section className="border border-gray-200 dark:border-gray-700 rounded-xl p-4" aria-label="Access expiring soon">
      <div className="flex items-baseline justify-between mb-1">
        <h3 className="text-sm font-semibold">Expiring in 60 days</h3>
        <span className="text-xs text-gray-500">ignores date filter</span>
      </div>
      <div className="flex items-baseline gap-2 mb-3">
        <span className="text-xl font-semibold text-gray-900 dark:text-gray-100">{money(expiring?.revenue_cents)}</span>
        <span className="text-xs text-gray-500">
          across {expiring?.count ?? 0} purchase{expiring?.count === 1 ? '' : 's'}
        </span>
      </div>

      {rows.length === 0 ? (
        <div className="text-xs text-gray-500">Nothing lapses in the next 60 days.</div>
      ) : (
        <ul className="space-y-1.5">
          {rows.map((p) => {
            const left = daysLeft(p.valid_until);
            return (
              <li key={p.id} className="flex items-baseline gap-2 text-xs">
                <span className="truncate text-gray-700 dark:text-gray-300" title={p.class_title}>{p.class_title}</span>
                <span className="ml-auto shrink-0 tabular-nums text-gray-500">{money(p.total_cents)}</span>
                {/* Orange is this app's warning color; the day count carries the
                    urgency in text so it never depends on the color alone. */}
                <span className={`shrink-0 tabular-nums ${left <= 14 ? 'text-orange-600 dark:text-orange-400 font-medium' : 'text-gray-500'}`}>
                  {left}d
                </span>
                <span className="sr-only">expires {formatDate(p.valid_until)}</span>
              </li>
            );
          })}
        </ul>
      )}
      {expiring?.count > rows.length && (
        <div className="text-xs text-gray-400 mt-2">Showing the {rows.length} soonest.</div>
      )}
    </section>
  );
}
